import { createFeatureSelector, createSelector } from '@ngrx/store';
export const getDebugFlagsState = createFeatureSelector('debugFlags');
/**
 * Selector to return the current settings for the Debug Flags
 */
export const getDebugFlagSettings = createSelector(getDebugFlagsState, state => state && state.settings);
/**
 * Selector to return the the Debug Flags are loaded
 */
export const getDebugFlagsLoaded = createSelector(getDebugFlagsState, state => state && state.isLoaded);
//# sourceMappingURL=debug-flag.selectors.js.map